import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { Holiday } from 'modules/shift_management/lib/types'

import BaseCell from '../BaseCell'
import * as styles from './index.vanilla.css'

interface Props {
  holiday: Holiday
}

const BankHolidayItem = ({ holiday }: Props) => {
  const [{ view }] = useSchedule()
  const typeTitle = holiday.halfDay
    ? i18n.t('shift_management.cells.half_bank_holiday.title')
    : i18n.t('shift_management.cells.bank_holiday.title')
  const label = holiday.halfDay ? `½ ${holiday.summary}` : holiday.summary

  return (
    <BaseCell
      tooltip={
        <Box gap="s4">
          <Text.Header3 color="grey000White">{typeTitle}</Text.Header3>
          <Text.Normal size="200" weight="normal" color="grey000White">
            {holiday.summary}
          </Text.Normal>
        </Box>
      }
      className={styles.timeOffCell}
      body={typeTitle}
      background="purple200"
      minHeight={view.cellMaxHeight}
    >
      {label}
    </BaseCell>
  )
}

export default observer(BankHolidayItem)
